import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureToggleService } from './feature-toggle.service';

@Directive({
  selector: '[shrdUtcFeatureToggleOn]'
})
export class FeatureToggleOnDirective implements OnInit {
  @Input() shrdUtcFeatureToggleOn: string;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly ftService: FeatureToggleService
  ) {}

  ngOnInit() {
    if (this.isEnabled()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  isEnabled() {
    return this.ftService.getToggleById(this.shrdUtcFeatureToggleOn);
  }
}
